const auxComp = (props) => props.children;

export default auxComp;


// WEBPACK FOOTER //
// ./src/hoc/AuxComp/AuxComp.js